import { defineContract } from "../defineContract";
import { SOCKET_EVENTS } from "../socketEvents";

export interface TagDTO {
  id: number;
  name: string;
  color: string;
  kanban: number;
  companyId: number;
}

/** Payload de SOCKET_EVENTS.TAG.LIST — o que TagController emite (store/update/remove/syncTags). */
export type TagEventPayload =
  | { action: "create"; tag: TagDTO }
  | { action: "update"; tag: TagDTO }
  // tagId vem direto de req.params (string) — TagController, diferente do
  // QueueController, não converte com +tagId antes de emitir.
  | { action: "delete"; tagId: string };

export const tagsContract = defineContract<void, TagDTO[], TagEventPayload>({
  route: "/tags/list",
  method: "GET",
  events: { changed: SOCKET_EVENTS.TAG.LIST },
  // A resposta traz os CONTATOS de cada tag, então mexer no vínculo também
  // muda a lista — e é por aí que os avisos mais escapavam (SyncTagsService,
  // callbacks de plugin, exclusão em massa de contatos).
  cache: { ttl: 10 * 60 * 1000, invalidatedBy: ["changed"] }
});
